import styled from 'styled-components';


const BuyButton = styled.button`
background:${props => props.fastorder ? '#8D7868' : '#A2692F'};
border-radius: 25px;
color:#fff;
font-style: normal;
font-weight: bold;
font-size: 14px;
text-transform: uppercase;
min-width:50%;
border:none;
padding: 10px 25px;
cursor:pointer;
 margin-bottom: 15px;
 :hover {
    box-shadow: 0px 3px 10px #A2692F;
  }
`

export default BuyButton;